import { render, staticRenderFns } from "./SolicitacoesCriar.vue?vue&type=template&id=2de1055c"
import script from "./SolicitacoesCriar.vue?vue&type=script&lang=js"
export * from "./SolicitacoesCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports